<script>
import EmbedIframe from '@/components/EmbedIframe.vue';
import css from '!!raw-loader!sass-loader!./widget.scss';
import appProgressBarCss from '!!raw-loader!sass-loader!@/assets/css/checkout/app-progress-bar.scss';
import utilitiesCss from '!!raw-loader!sass-loader!@/assets/css/checkout/utilities.scss';

export default {
  name: 'GoalWidgetIframe',
  components: { EmbedIframe },
  props: {
    height: { type: String, default: '278px' }
  },
  data: () => ({ css: css + appProgressBarCss + utilitiesCss })
};
</script>

<template>
  <embed-iframe title="Progress bar Widget" name="double-goal-mete-widget" :height="height" :css="css">
    <slot />
  </embed-iframe>
</template>
